var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rich-text-container",class:_vm.classes},[(_vm.data.text)?_c('Element',{attrs:{"data":_vm.data.text,"linkColor":_vm.linkColor}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }